import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleMapsLoader } from './utils/GoogleMapsLoader';
import HomePage from './pages/HomePage';
import DiscPage from './pages/DiscPage';
import AdminPanel from './pages/AdminPanel';

function App() {
    return (
        <GoogleMapsLoader>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/disc/:discId" element={<DiscPage />} />
                    <Route path="/admin" element={<AdminPanel />} />
                </Routes>
            </BrowserRouter>
        </GoogleMapsLoader>
    );
}

export default App;